<span class="esn-sidebar-section__label" aria-hidden="true">{{ label() }}</span>
<ng-content />
